import { AnalyticsFilterState } from "@/core/entities/analytics/AnalyticsFilterState";
import { IAnalyticsFilterStateRepository } from "@/core/repositories/analyticsFilterState";
import { LocalStorageAdapter } from "@/infrastructure/adapters/localStorage";
import { JsonSerializer } from "@/infrastructure/serializers/JsonSerializer";
import { createLogger, ILogger } from "@/infrastructure/services/logger";

export class AnalyticsFilterStateRepository implements IAnalyticsFilterStateRepository {
  private readonly storage: LocalStorageAdapter;
  private readonly logger: ILogger = createLogger("AnalyticsFilterStateRepository");
  private readonly STORAGE_KEY = "analytics_filter_state";

  constructor() {
    this.storage = new LocalStorageAdapter(new JsonSerializer(), "irApp");
  }

  async getAnalyticsFilterState(): Promise<AnalyticsFilterState | null> {
    try {
      const item = await this.storage.retrieve<AnalyticsFilterState>(this.STORAGE_KEY);
      return item?.value ?? null;
    } catch (error) {
      this.logger.error("Failed to get analytics filter state", error);
      return null;
    }
  }

  async saveAnalyticsFilterState(state: AnalyticsFilterState): Promise<void> {
    try {
      await this.storage.store({ key: this.STORAGE_KEY, value: state });
    } catch (error) {
      this.logger.error("Failed to save analytics filter state", error);
    }
  }

  async resetAnalyticsFilterState(): Promise<void> {
    try {
      await this.storage.delete(this.STORAGE_KEY);
    } catch (error) {
      this.logger.error("Failed to reset analytics filter state", error);
    }
  }
}
